import { SingleSearchParam } from "./SingleSearchParam";

export class InstitutionsSearchParams {

  page: SingleSearchParam;
  /** The Go API's token for `page`; empty for the first page. */
  pageToken: SingleSearchParam;
  sortBy: SingleSearchParam;
  sortDir: SingleSearchParam;
  q: SingleSearchParam;

  serialized: string;
  
  constructor(params: any) {
    this.q = new SingleSearchParam(params.q || '')
    this.page = new SingleSearchParam(params.page || 1)
    this.pageToken = new SingleSearchParam(params.pageToken || '')
    this.sortBy = new SingleSearchParam(params.sortBy || 'name')
    this.sortDir = new SingleSearchParam(params.sortDir || 'desc')
    this.serialized= this.serialize()
  }

  serialize(page?: string, pageToken?: string) {
    const searchParams = new URLSearchParams()
    searchParams.set('q', this.q.serialize());
    searchParams.set('page', page ? page : this.page.serialize());
    const token = page ? pageToken : this.pageToken.value
    if (token) searchParams.set('pageToken', token);
    searchParams.set('sortBy', this.sortBy.serialize());
    searchParams.set('sortDir', this.sortDir.serialize());
    return searchParams.toString()
  }

  raw() {
    return {
      page: this.page.value,
      sortBy: this.sortBy.value,
      sortDir: this.sortDir.value,
      serialized: this.serialized,
      q: this.q.value,
    }
  }

  toBody() {
    return {
      sortBy: this.sortBy.value,
      sortDir: this.sortDir.value,
      page: this.page.value,
      q: this.q.value,
    }
  }
}